import Vue from 'vue';
import Vuex from "vuex";
Vue.use(Vuex);

const user = sessionStorage.getItem("loginuser");
const store = new Vuex.Store({
    state: {
        user: user?JSON.parse(user):{}
    },
    mutations: {
        setUser(state, u) {
            state.user = u;
            if (u.datamem && u.reportmem) {
                u.mem = "高级会员";
            } else if (u.datamem) {
                u.mem = "数据大会员";
            } else if (u.reportmem) {
                u.mem = "报告大会员";
            } else {
                u.mem = "普通用户";
            }
            sessionStorage.setItem("loginuser", JSON.stringify(u));
        },
        clearUser(state) {
            state.user = {};
            sessionStorage.removeItem("loginuser");
        }
    },
});
export default store;
